module.exports = __webpack_public_path__ + "fonts/Canaro-BookItalic.7880758b.woff2";